/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { FC, ReactNode, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import { KeyboardShortcuts } from '@components/keyboard-shortcuts';
import { Maintenance } from '@components/modals/maintenance';
import { DEFAULT_CURRENCY } from '@constants';
import { MobileSlider } from '@containers/mobile-slider';
import { getActiveAccount, initBeacon } from '@lib/beacon';
// import { CheckMaintenance } from '@lib/versum/admin';
import { actions } from '@state/auth';
import { actions as globalActions } from '@state/global';
import { RootState } from '@state/store';

import * as Styles from './styles';

const PreloaderWithNoSSR = dynamic(() => import('./preloader'), { ssr: false });
const Header = dynamic<any>(import('@containers/header').then((e) => e.Header));
const ModalManager = dynamic<any>(import('@components/modal-manager').then((e) => e.ModalManager));
const Footer = dynamic<any>(import('@components/footer').then((e) => e.Footer));

export interface IApplication {
  children: ReactNode;
}

export const Application: FC<IApplication> = ({ children }) => {
  const router = useRouter();
  const [maintenance, setMaintenance] = useState<boolean | undefined>(false);
  const dispatch = useDispatch();
  const { ready } = useSelector((state: RootState) => state.global);

  useEffect(() => {
    async function init() {
      if (!ready) {
        const isMaintenance = false; // await CheckMaintenance();
        setMaintenance(isMaintenance);
        if (isMaintenance) {
          return;
        }

        initBeacon();
        const account = await getActiveAccount();
        if (account) {
          dispatch({ type: actions.AUTH_LOGIN, payload: account });
        } else {
          dispatch({ type: globalActions.GLOBAL_GET_TEZOS, payload: DEFAULT_CURRENCY });
          dispatch({ type: globalActions.GLOBAL_GET_CURRENCIES });
          dispatch({ type: globalActions.GLOBAL_READY, payload: true });
        }
      }
    }

    init();
  }, []);

  return (
    <>
      <MobileSlider>
        {maintenance === false && (
          <Styles.Container
            css={{
              opacity: ready ? 1 : 0,
              pointerEvents: ready ? 'all' : 'none',
            }}
          >
            {!['/mint/process', '/mint/check'].includes(router.pathname) && <Header />}
            {children}
            <Footer />
          </Styles.Container>
        )}
      </MobileSlider>

      <ModalManager />

      <KeyboardShortcuts />

      <PreloaderWithNoSSR show={!ready} />

      <Maintenance open={maintenance} />
    </>
  );
};
